import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const footerLinks = [
    { label: "Home", to: "/" },
    { label: "Lessons", to: "/lessons" },
    { label: "Practice", to: "/practice" },
    { label: "Test", to: "/test" },
    { label: "Utilities", to: "/utilities" },
    { label: "Blog", to: "/blog" },
    { label: "About Us", to: "/about" },
    { label: "Contact Us", to: "/contact" },
    { label: "Privacy Policy", to: "/privacy" },
];

export default function Footer() {
    return (
        <footer
            className="mt-16 border-t border-[var(--lt-border)] bg-[#0E1116]"
            data-testid="global-footer"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
                <div className="grid gap-10 md:grid-cols-3">
                    <div>
                        <img src="/logo-96.png" alt="" width="40" height="40" className="h-10 w-10 mb-3" data-testid="footer-logo" />
                        <p
                            className="text-2xl font-semibold tracking-tight"
                            style={{
                                fontFamily:
                                    '"Plus Jakarta Sans", ui-sans-serif, system-ui, sans-serif',
                            }}
                        >
                            <span className="text-[var(--lt-terracotta)]">Lipi</span>Typing
                        </p>
                        <p className="text-sm text-[var(--lt-muted)] mt-3 leading-relaxed max-w-sm">
                            A specialized bilingual typing tutor for English and
                            Traditional Nepali (Devanagari). Structured lessons,
                            timed tests, and Nepal-focused utilities in one clean
                            workspace.
                        </p>
                    </div>

                    <nav aria-label="Footer navigation">
                        <h2 className="eyebrow mb-4">Explore</h2>
                        <ul className="grid grid-cols-2 gap-y-2 gap-x-6 text-sm">
                            {footerLinks.map((l) => (
                                <li key={l.to}>
                                    <Link
                                        to={l.to}
                                        className="text-[var(--lt-muted)] hover:text-[var(--lt-text)] transition-colors"
                                        data-testid={`footer-link-${l.label
                                            .toLowerCase()
                                            .replace(/\s+/g, "-")}`}
                                    >
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <div>
                        <h2 className="eyebrow mb-4">Get in Touch</h2>
                        <a
                            href="mailto:hello@lipityping.com"
                            className="text-sm text-[var(--lt-muted)] hover:text-[var(--lt-text)] inline-flex items-center gap-2"
                            data-testid="footer-email"
                        >
                            <Mail size={14} /> hello@lipityping.com
                        </a>
                        <p className="text-xs text-[var(--lt-muted)] mt-6 leading-relaxed">
                            LipiTyping is an independent educational product. Made
                            with care in the Himalayas.
                        </p>
                    </div>
                </div>

                <div className="mt-10 pt-6 border-t border-[var(--lt-border)] flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-[var(--lt-muted)]">
                    <p>© 2026 LipiTyping. All rights reserved.</p>
                    <p>
                        Built for learners of English &amp; नेपाली typing.
                    </p>
                </div>
            </div>
        </footer>
    );
}
